import { Directive } from '@angular/core';

@Directive({
  selector: '[treeEditNodeDef]'
})
export class TreeEditNodeDefDirective {}
